import { ComboBox, IComboBoxOption, Label, Stack } from '@fluentui/react'
import { UserFilterOption } from '../../api/models'

type UserFilterProps = {
  users: UserFilterOption[]
  selectedUserId?: string
  onChange: (userId: string | undefined) => void
}

const CLIENTS_ONLY_KEY = '__clients_only__'

const UserFilter = ({ users, selectedUserId, onChange }: UserFilterProps) => {
  const options: IComboBoxOption[] = [
    { key: 'all', text: 'All Users' },
    { key: CLIENTS_ONLY_KEY, text: 'Clients Only (exclude CEM)' },
    ...users.map((u) => ({ key: u.id, text: `${u.name} (${u.email})` })),
  ]

  const displayKey = selectedUserId ?? 'all'

  return (
    <Stack>
      <Label>User</Label>
      <ComboBox
        selectedKey={displayKey}
        options={options}
        autoComplete="on"
        allowFreeInput
        onChange={(_, option) => {
          if (!option) return
          if (option.key === 'all') {
            onChange(undefined)
          } else if (option.key === CLIENTS_ONLY_KEY) {
            onChange(CLIENTS_ONLY_KEY)
          } else {
            onChange(option.key as string)
          }
        }}
        styles={{ root: { width: 280 } }}
      />
    </Stack>
  )
}

export { CLIENTS_ONLY_KEY }
export default UserFilter
